import { TaskActions } from 'actions';
import { RaisedButton } from 'material-ui';
import React, { Component, PropTypes } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

export default class TaskResultList extends Component {
  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  static propTypes = {
    results: PropTypes.array,
    ListElement: PropTypes.func,
    choices: PropTypes.array,
    taskId: PropTypes.number,
    correctResponse: PropTypes.object,
    canGrade: PropTypes.bool,
    removeAnimation: PropTypes.bool,
    feedback: PropTypes.array
  };

  render() {
    let {
      results,
      ListElement,
      choices,
      taskId,
      correctResponse,
      canGrade,
      removeAnimation
    } = this.props;

    const tasks = [];
    if(results && !!results.length){
      for (let i = 0; i < results.length; i++) {
        const result = results[i];
        if (result) {
          const { user } = result;
          tasks.push(
            <div key={result.id}>
              {canGrade && user && user.name}
              <ListElement
                feedback={this.props.feedback}
                taskId={taskId}
                {...result}
                choices={choices}
                id={result.id}
                correctResponse={correctResponse}
                canGrade={canGrade}
              />
              {canGrade && !!result.bodyFiles.length && (
                <RaisedButton
                  style={{
                    margin: '0px 8px',
                    width: 'calc(100% - 16px)',
                    marginBottom: 16,
                    minWidth: 'auto'
                  }}
                  onClick={() => TaskActions.removeUploaded(result.id)}
                  fullWidth
                  label="Remove attached files"
                />
              )}
            </div>
          );
        }
      }
    }

    if (removeAnimation) {
      return (
        <div>{tasks}</div>
      )
    }

    return (
      <ReactCSSTransitionGroup
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
        transitionName={'task-result'}
      >
        {tasks}
      </ReactCSSTransitionGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Task/TaskResultList.js